import { getRandomId as getRandomNodeId, ROOT_NODE } from "@craftjs/utils";
import { blocksLibrary } from "../blocks";
import { waitForElement } from "../dom";

function wrap(actions, query, type, document = window.document) {
  if (!query || !actions) {
    return;
  }

  if (!type) {
    return;
  }

  if (!blocksLibrary[type]) {
    return;
  }

  var selectedBlocks = query.getEvent("selected");
  var id = selectedBlocks.last();
  const nodeID = getRandomNodeId();
  const freshNode = {
    id: nodeID,
    data: {
      type: blocksLibrary[type],
      isCanvas: true,
    },
  };
  const nodeToAdd = query.parseFreshNode(freshNode).toNode();
  const parents = query.node(id).ancestors();
  var node_parent = undefined;
  var node_index = undefined;
  if (parents && parents.length > 0) {
    node_parent = parents[0];
  }
  if (node_parent) {
    let parentChildrens = query.node(node_parent).childNodes();
    node_index = parentChildrens.indexOf(id) + 1;
  }
  actions.add(nodeToAdd, node_parent, node_index);
  actions.move(selectedBlocks.all(), nodeID, 0);

  waitForElement(document, `[data-grigora-block-id='${nodeID}']`).then(
    (elm) => {
      actions.selectNode(nodeID);
    },
  );
}

export default wrap;
